import { useState } from 'react';
import { DateTime } from 'luxon';
import language from '../../variables/language';

// Must match .clients-chart-bars{height} in clients-list.css - the gradient
// below is pinned to this pixel height so every bar reads as a crop of the
// SAME cold(bottom)->hot(top) scale, not its own height squeezed into one.
const CHART_HEIGHT_PX = 130;
const BAR_GRADIENT = 'linear-gradient(to top, #63dac8 0%, #4ade80 28%, #ffd23f 55%, #ff8a3d 78%, #ff5140 100%)';

// Single-series column chart (client signups per month, last 6 months).
// Per the dataviz skill: one series needs no legend, every bar is directly
// labeled with its value so gridlines/axis ticks are skippable, and the
// hover/focus tooltip is the hit-target-is-bigger-than-the-mark layer. Every
// bar samples the same fixed cold->hot gradient from its bottom - a tall bar
// reaches further into the warm end, a short one only shows the cool base.
export default function ClientsChart({ monthly }) {
   const [hovered, setHovered] = useState(null);

   const months = Array.isArray(monthly) ? monthly : [];
   const max = Math.max(1, ...months.map(m => m.count || 0));
   const monthNames = language[language.lang].clientsPage.months;

   const shortLabel = (ym) => {
      const dt = DateTime.fromFormat(ym, 'yyyy-MM');
      return dt.isValid ? monthNames[dt.month - 1] : ym;
   }
   const fullLabel = (ym) => {
      const dt = DateTime.fromFormat(ym, 'yyyy-MM');
      return dt.isValid ? monthNames[dt.month - 1] + ' ' + dt.year : ym;
   }

   return (
      <div className='clients-chart'>
         <div className='clients-chart-bars'>
            {months.map((m, i) => (
               <div className='clients-chart-bar-col' key={m.month} tabIndex={0}
                  aria-label={fullLabel(m.month) + ': ' + m.count}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(prev => prev === i ? null : prev)}
                  onFocus={() => setHovered(i)}
                  onBlur={() => setHovered(prev => prev === i ? null : prev)}>
                  {hovered === i ? (
                     <div className='clients-chart-tooltip'>{fullLabel(m.month)}: <b>{m.count}</b></div>
                  ) : ''}
                  <span className='clients-chart-bar-value'>{m.count}</span>
                  <div className='clients-chart-bar' style={{
                     height: ((m.count || 0) / max * 100) + '%',
                     backgroundImage: BAR_GRADIENT,
                     backgroundSize: '100% ' + CHART_HEIGHT_PX + 'px',
                     backgroundPosition: 'bottom',
                     backgroundRepeat: 'no-repeat',
                  }}></div>
               </div>
            ))}
         </div>
         <div className='clients-chart-labels'>
            {months.map(m => (
               <span className='clients-chart-bar-label' key={m.month}>{shortLabel(m.month)}</span>
            ))}
         </div>
      </div>
   )
}
